import React, { useState } from 'react';
import { auth } from '../firebaseConfig';
import RoomManagement from './RoomManagement';
import UserManagement from './UserManagement';
// Import your new components here (create these files next!)
import ReportsManagement from './ReportsManagement';
import DeleteRequests from './DeleteRequests';

function AdminDashboard({ user }) {
  const [activeTab, setActiveTab] = useState('rooms');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      alert('Failed to log out.');
    }
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @media (max-width: 768px) {
            .sidebar { position: fixed; left: ${isMobileMenuOpen ? '0' : '-250px'}; z-index: 1000; height: 100vh; }
            .main-content { margin-left: 0 !important; }
            .menu-toggle { display: block !important; }
          }
        `}
      </style>

      {/* Sidebar */}
      <div style={styles.sidebar} className="sidebar">
        <div style={styles.logoContainer}>
          <img src="/appicon.png" alt="Logo" style={styles.logo} />
          <h2 style={styles.adminTitle}>Find My Room</h2>
          <h3 style={styles.adminSubTitle}>Admin Panel</h3>
        </div>

        <ul style={styles.navList}>
          <li style={activeTab === 'rooms' ? styles.navItemActive : styles.navItem} onClick={() => setActiveTab('rooms')}>Rooms</li>
          <li style={activeTab === 'users' ? styles.navItemActive : styles.navItem} onClick={() => setActiveTab('users')}>Users</li>
          <li style={activeTab === 'reports' ? styles.navItemActive : styles.navItem} onClick={() => setActiveTab('reports')}>Reported</li>
          <li style={activeTab === 'requests' ? styles.navItemActive : styles.navItem} onClick={() => setActiveTab('requests')}>Requests</li>
        </ul>

        <button onClick={handleLogout} style={styles.logoutButton}>Logout</button>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent} className="main-content">
        <div style={styles.topBar}>
          <button style={styles.menuToggle} className="menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>☰</button>
          <h1 style={styles.pageTitle}>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h1>
          <span style={styles.adminEmail}>Admin: {user.email}</span>
        </div>

        <div style={styles.contentArea}>
          {activeTab === 'rooms' && <RoomManagement />}
          {activeTab === 'users' && <UserManagement />}
          {activeTab === 'reports' && <ReportsManagement />}
          {/* {activeTab === 'reports' && <div style={styles.placeholder}>Reported Rooms Component</div>} */}
          {activeTab === 'requests' && <DeleteRequests />}
        </div>
        <div style={{display: 'flex', justifyContent: 'flex-end'}} >
          <p>Developed By: Bikram Kumal.</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { 
    display: 'flex', 
    minHeight: '100vh', 
    backgroundColor: '#f1f5f9', 
    fontFamily: 'Inter, sans-serif' 
  },

  sidebar: { 
    width: '250px', 
    backgroundColor: '#1e293b', 
    color: 'white', 
    padding: '20px', 
    transition: '0.3s' 
  },

  logoContainer: { 
    textAlign: 'center', 
    marginBottom: '40px' 
  },

  logo: { 
    width: '60px', 
    height: '60px', 
    borderRadius: '12px', 
    marginBottom: '10px' 
  },

  adminTitle: { 
    fontSize: '20px', 
    color: '#38bdf8' 
  },

  adminSubTitle: { 
    fontSize: '18px', 
    color: '#7b99a6' 
  },

  navList: { 
    listStyle: 'none', 
    padding: 0 
  },

  navItem: { 
    padding: '15px', 
    cursor: 'pointer', 
    borderRadius: '8px', 
    marginBottom: '10px', 
    color: '#94a3b8', 
    fontSize: '16px' 
  },

  navItemActive: { 
    padding: '15px', 
    cursor: 'pointer', 
    borderRadius: '8px', 
    marginBottom: '10px', 
    backgroundColor: '#3b82f6', 
    color: 'white', 
    fontWeight: '600' 
  },

  logoutButton: { 
    width: '100%', 
    padding: '12px', 
    backgroundColor: '#ef4444', 
    color: 'white', 
    border: 'none', 
    borderRadius: '8px', 
    cursor: 'pointer', 
    marginTop: 'auto' 
  },

  mainContent: { 
    flexGrow: 1, 
    padding: '20px', 
    marginLeft: '0px' 
  },

  topBar: { 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between', 
    marginBottom: '30px', 
    backgroundColor: 'white', 
    padding: '15px', 
    borderRadius: '12px', 
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
  },

  menuToggle: { 
    display: 'none', 
    background: 'none', 
    border: 'none', 
    fontSize: '24px', 
    cursor: 'pointer' 
  },

  pageTitle: { 
    fontSize: '24px', 
    color: '#1e293b', 
    margin: 0 
  },

  adminEmail: { 
    fontSize: '14px', 
    color: '#64748b' 
  },

  contentArea: { 
    backgroundColor: 'white', 
    padding: '20px', 
    borderRadius: '12px', 
    minHeight: '400px' 
  },

  placeholder: { 
    textAlign: 'center', 
    padding: '50px', 
    color: '#94a3b8' 
  }
};

export default AdminDashboard;